<div class="app-modal__backdrop" tabindex="-1" (mousedown)="onBackdropClick($event)" (keydown.escape)="close()">
	@if (filedropEnabled()) {
	<app-filedrop #modalFiledrop class="app-modal__filedrop" variant="content" [mediaUpload]="mediaUpload()"
		[disabled]="filedropDisabled()" [extensions]="filedropExtensions()" [maxFileSizeMb]="filedropMaxFileSizeMb()"
		[maxFiles]="filedropMaxFiles()" [showUploadQueue]="filedropShowUploadQueue()"
		[maxConcurrentUploads]="filedropMaxConcurrentUploads()"
		[uploadQueueDisplayThreshold]="filedropUploadQueueDisplayThreshold()"
		(mediaUploaded)="mediaUploaded.emit($event)" (mediaUploadStarted)="mediaUploadStarted.emit($event)"
		(mediaUploadProgress)="mediaUploadProgress.emit($event)"
		(mediaUploadCompleted)="mediaUploadCompleted.emit($event)" (mediaUploadFailed)="mediaUploadFailed.emit($event)"
		(filesSelected)="filesSelected.emit($event)" (filesRejected)="filesRejected.emit($event)">
		<ng-container [ngTemplateOutlet]="modalDialog"></ng-container>
	</app-filedrop>
	} @else {
	<ng-container [ngTemplateOutlet]="modalDialog"></ng-container>
	}
</div>

<ng-template #modalDialog>
	<dialog #dialog class="app-modal" [class.app-modal--allow-overflow]="allowOverflow()" open aria-modal="true" [attr.aria-label]="ariaLabel() || title()"
		[style.width]="width()" [style.height]="height()" [style.min-height]="minHeight()"
		[style.max-height]="maxHeight()" (click)="stopDialogEvent($event)" (keydown)="stopDialogEvent($event)">
		@if (showHeader()) {
		<header class="app-modal__header">
			@if (icon() && title() && subtitle()) {
			<app-icon-name-desc [icon]="icon()" [title]="title()" [description]="subtitle()" [fontSize]="'md'"
				[iconHeight]="30" [iconWidth]="30" [color]="'transparent'"></app-icon-name-desc>
			} @else {
			<div>
				@if (title()) {
				<h2>{{ title() }}</h2>
				}

				@if (subtitle()) {
				<p>{{ subtitle() }}</p>
				}
			</div>
			}
			<button type="button" class="app-modal__close" (click)="close()"
				[attr.aria-label]="closeButtonText()">&times;</button>
		</header>
		}

		<div class="app-modal__content">
			<ng-content></ng-content>
		</div>

		@if (showFooter()) {
		<footer class="app-modal__footer">
			<div class="app-modal__footer-left">
				@if (showExtraButton()) {
				<app-button [buttonType]="extraButtonType()" size="sm" [horizontalPadding]="true"
					[disabled]="extraDisabled()" (pressed)="extra()">
					{{ extraButtonText() }}
				</app-button>
				}
			</div>

			<div class="app-modal__footer-right">
				@if (showConfirmButton()) {
				<app-button [buttonType]="confirmButtonType()" size="sm" [horizontalPadding]="true"
					[preIcon]="confirmButtonIcon()" [iconWidth]="16" [iconHeight]="16" [disabled]="confirmDisabled()"
					(pressed)="confirm()" [iconColor]="'currentColor'" >
					{{ confirmButtonText() }}
				</app-button>
				}

				<app-button buttonType="secondary" size="sm" [horizontalPadding]="true" [disabled]="closeDisabled()"
					(pressed)="close()">
					{{ closeButtonText() }}
				</app-button>
			</div>
		</footer>
		}
	</dialog>
</ng-template>
